<script setup lang="ts">
import { useCarouselContext } from '@shared/fondof-ui/components/molecules/carousel/useCarouselContext'
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'
import clsx from 'clsx'

const { axis } = useCarouselContext()

const props = defineProps<HTMLAttributeClass>()

const { emblaRef } = useCarouselContext()
</script>

<template>
  <div
    ref="emblaRef"
    :class="clsx('h-full w-auto overflow-hidden')"
  >
    <div
      :class="
        clsx(
          'flex w-full',
          {
            'flex-col': axis === 'y',
          },
          props.class
        )
      "
    >
      <slot />
    </div>
  </div>
</template>
